import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MonoTypeOperatorFunction } from 'rxjs';

@Component({
  selector: 'app-base',
  template: '',
})
export class BaseComponent {
  protected readonly destroyRef = inject(DestroyRef);

  protected untilDestroyed<T>(): MonoTypeOperatorFunction<T> {
    return takeUntilDestroyed<T>(this.destroyRef);
  }
}
